module.exports = __webpack_public_path__ + "img/Tutorial_ExtendedSearch.b6e96925.jpg";